<template>
    <div class="rd-list">
        <loading
            :active.sync="open_loader"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#6366f1'"
        ></loading>

        <header class="rd-list__head">
            <div>
                <h1 class="rd-list__title">SSU bodovi</h1>
                <p class="rd-list__sub">Stručno usavršavanje člana.</p>
            </div>
            <router-link to="/" class="rd-back">← Natrag</router-link>
        </header>

        <div v-if="osoba">
            <section class="rd-summary">
                <div class="rd-summary__info">
                    <div class="rd-summary__row"><span>Ime i prezime</span><strong>{{ osoba.ime }} {{ osoba.prezime }}</strong></div>
                    <div class="rd-summary__row"><span>OIB</span><strong>{{ osoba.oib }}</strong></div>
                    <div class="rd-summary__row"><span>Razdoblje</span><strong>{{ osoba.osoba_aktualno_razdoblje ? ( osoba.osoba_aktualno_razdoblje.datum_od + ' – ' + osoba.osoba_aktualno_razdoblje.datum_do ) : '—' }}</strong></div>
                </div>
                <div class="rd-stats">
                    <div class="rd-stat"><span class="rd-stat__num">{{ sati }}</span><span class="rd-stat__lbl">Sati</span></div>
                    <div class="rd-stat"><span class="rd-stat__num">{{ sati_regulativa }}</span><span class="rd-stat__lbl">Sati regulativa</span></div>
                </div>
            </section>

            <section v-if="stavke.length" class="rd-tablecard">
                <h2 class="rd-tablecard__title">Skupovi</h2>
                <div class="rd-tablewrap">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>Datum</th><th>Status</th><th>Naziv skupa</th>
                            <th style="width: 10%">Sati</th><th style="width: 10%">Sati regulativa</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="stavka in stavke" :key="stavka.id">
                            <td>{{ stavka.datum }}</td>
                            <td>{{ stavka.vrsta_sudionika.naziv }}</td>
                            <td>{{ stavka.skup.naziv }}</td>
                            <td>{{ stavka.sati }}</td>
                            <td>{{ stavka.sati_regulativa }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <section v-if="dodatne_aktivnosti.length" class="rd-tablecard">
                <h2 class="rd-tablecard__title">Dodatne aktivnosti</h2>
                <div class="rd-tablewrap">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>Datum od</th><th>Datum do</th><th>Opis</th>
                            <th style="width: 10%">Sati</th><th style="width: 10%">Sati regulativa</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="dodatna_aktivnost in dodatne_aktivnosti" :key="dodatna_aktivnost.id">
                            <td>{{ dodatna_aktivnost.datum_od }}</td>
                            <td>{{ dodatna_aktivnost.datum_do }}</td>
                            <td>{{ dodatna_aktivnost.opis }}</td>
                            <td>{{ dodatna_aktivnost.sati }}</td>
                            <td>{{ dodatna_aktivnost.sati_regulativa }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import moment from "moment/moment";
export default {
    name: "BodoviComponent",
    components: {
        Loading
    },
    data(){
        return{
            open_loader: false,
            app_owner: process.env.VUE_APP_APP_OWNER,

            osoba: {},
            stavke: [],
            dodatne_aktivnosti: [],
        }
    },
    computed: {
        sati(){
            let vm = this

            let sati = 0

            vm.stavke.forEach( stavka => {
                sati += stavka.sati
            } )
            vm.dodatne_aktivnosti.forEach( dodatna_aktivnost => {
                sati += dodatna_aktivnost.sati
            } )

            return sati
        },
        sati_regulativa(){
            let vm = this

            let sati_regulativa = 0

            vm.stavke.forEach( stavka => {
                sati_regulativa += stavka.sati_regulativa
            } )
            vm.dodatne_aktivnosti.forEach( dodatna_aktivnost => {
                sati_regulativa += dodatna_aktivnost.sati_regulativa
            } )

            return sati_regulativa
        }
    },
    methods:{
        async fetchRazdoblja(){

            let vm=this
            vm.open_loader=true



            const osoba = await axios.get( process.env.VUE_APP_API_URL + 'izzyedu/osoba', {} )
            vm.osoba = osoba.data.data[osoba.data.data.length - 1 ]

            if( !vm.osoba.osoba_aktualno_razdoblje )
                return

            let razdoblje_od = vm.osoba.osoba_aktualno_razdoblje.datum_od ? moment( vm.osoba.osoba_aktualno_razdoblje.datum_od, 'DD.MM.YYYY.' ) : null
            let razdoblje_do = vm.osoba.osoba_aktualno_razdoblje.datum_do ? moment( vm.osoba.osoba_aktualno_razdoblje.datum_do, 'DD.MM.YYYY.' ) : null

            if( !razdoblje_od ){
                razdoblje_od = razdoblje_do.clone()
                razdoblje_od.add( '2', 'years' )
            }

            if( !razdoblje_do ){
                razdoblje_do = razdoblje_od.clone()
                razdoblje_do.subtract( '2', 'years' )
            }


            const stavke = await axios.get( process.env.VUE_APP_API_URL + 'izzyedu/stavka', {
                params:{
                    filters:{
                        skup_datum_i_vrijeme_od: {
                            from: razdoblje_od.format( 'DD.MM.YYYY' ),
                            to:razdoblje_do.format( 'DD.MM.YYYY' ),
                        },
                    }
                }
            } )
            const dodatne_aktivnosti = await axios.get( process.env.VUE_APP_API_URL + 'izzyedu/osoba-dodatna-aktivnost', {
                params: {
                    filters:{
                        datum_od: {
                            from: razdoblje_od.format( 'DD.MM.YYYY' ),
                            to:razdoblje_do.format( 'DD.MM.YYYY' ),
                        },
                    }
                }
            } )

            vm.stavke = stavke.data.data
            vm.dodatne_aktivnosti = dodatne_aktivnosti.data.data

            vm.open_loader=false

        }
    },
    async mounted() {
        await this.fetchRazdoblja()
    }

}
</script>

<style scoped>
.rd-list__head {
    display: flex; align-items: flex-end; justify-content: space-between;
    gap: 1rem; margin-bottom: 1.75rem; flex-wrap: wrap;
}
.rd-list__title { font-size: 1.8rem; font-weight: 800; margin: 0; }
.rd-list__sub { color: var(--rd-muted, #6b7280); margin: .3rem 0 0; }

.rd-back {
    font-weight: 700; color: var(--rd-primary-600, #4f46e5);
    background: var(--rd-primary-50, #eef2ff); padding: .55rem 1.1rem;
    border-radius: 12px; white-space: nowrap; transition: background .15s ease;
}
.rd-back:hover { background: #e3e7ff; }

/* summary */
.rd-summary {
    display: flex; flex-wrap: wrap; gap: 1.5rem; align-items: center;
    justify-content: space-between;
    background: #fff; border: 1px solid var(--rd-border, #e6e8f0);
    border-radius: var(--rd-radius, 18px); box-shadow: var(--rd-shadow, 0 12px 28px -8px rgba(16,24,40,.14));
    padding: 1.75rem; margin-bottom: 1.5rem;
}
.rd-summary__info { display: flex; flex-direction: column; gap: .55rem; }
.rd-summary__row { display: flex; flex-direction: column; }
.rd-summary__row span { color: var(--rd-muted, #6b7280); font-size: .8rem; text-transform: uppercase; letter-spacing: .4px; font-weight: 600; }
.rd-summary__row strong { font-size: 1.05rem; color: var(--rd-text, #1e2330); }

.rd-stats { display: flex; gap: 1rem; }
.rd-stat {
    min-width: 130px; text-align: center; padding: 1.25rem 1rem;
    border-radius: var(--rd-radius-sm, 12px);
    background: var(--rd-gradient, linear-gradient(135deg, #6366f1, #7c3aed));
    color: #fff; box-shadow: 0 12px 24px -10px rgba(99,102,241,.7);
}
.rd-stat__num { display: block; font-size: 2rem; font-weight: 800; line-height: 1; }
.rd-stat__lbl { display: block; margin-top: .4rem; font-size: .8rem; opacity: .9; font-weight: 600; }

/* table cards */
.rd-tablecard {
    background: #fff; border: 1px solid var(--rd-border, #e6e8f0);
    border-radius: var(--rd-radius, 18px); box-shadow: var(--rd-shadow, 0 12px 28px -8px rgba(16,24,40,.14));
    padding: 1.5rem 1.75rem; margin-bottom: 1.5rem;
}
.rd-tablecard__title { font-size: 1.2rem; font-weight: 700; margin: 0 0 1rem; }
.rd-tablewrap { overflow-x: auto; }
.rd-tablecard .table { box-shadow: none; margin: 0; }

@media (max-width: 640px) {
    .rd-summary { flex-direction: column; align-items: stretch; }
    .rd-stats { justify-content: stretch; }
    .rd-stat { flex: 1; min-width: 0; }
}
</style>
